import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { FiFilter, FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../../../tests/types";
import { selectFiltersStats, selectMobileFiltersOpen, useSelector } from "../../../../store/selectors";
import { useStoreSlices } from "../../../../store/slices";
export const MobileSearchSuffix = () => {
  const $ = _c(18);
  const stats = useSelector(selectFiltersStats);
  const mobileFiltersOpen = useSelector(selectMobileFiltersOpen);
  const {
    setMobileFiltersOpen
  } = useStoreSlices();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== mobileFiltersOpen || $[3] !== setMobileFiltersOpen) {
    t2 = () => setMobileFiltersOpen(!mobileFiltersOpen);
    $[2] = mobileFiltersOpen;
    $[3] = setMobileFiltersOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-4 w-px bg-slate-200 dark:bg-slate-700" />;
    t4 = <span className="text-xs font-medium text-slate-600 dark:text-slate-300">Filtry</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== mobileFiltersOpen || $[8] !== mounted) {
    t5 = <button type="button" className="flex items-center justify-center w-7 h-7 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400" aria-label="Toggle Filters">{mounted && mobileFiltersOpen ? <FiX /> : <FiFilter />}</button>;
    $[7] = mobileFiltersOpen;
    $[8] = mounted;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== stats.appliedFiltersCount) {
    t6 = stats.appliedFiltersCount > 0 && <span data-testid={TestIdEnum.MobileFiltersCount} className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-brand-600 rounded-full">{stats.appliedFiltersCount}</span>;
    $[10] = stats.appliedFiltersCount;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="relative">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t7) {
    t8 = <div className="flex items-center lg:hidden"><div className="flex items-center gap-2 cursor-pointer" data-testid={TestIdEnum.MobileFiltersButton} onClick={t2}>{t3}{t4}{t7}</div></div>;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};